import store from '../../store'
import websdk from "easemob-websdk";
// import emedia from "easemob-emedia";
import webrtc from "easemob-webrtc";
import config from "./WebIMConfig";

function ack(message) {
	var bodyId = message.id; // 需要发送已读回执的消息id
	var msg = new WebIM.message("read", WebIM.conn.getUniqueId());
	msg.set({
		id: bodyId,
		to: message.from
	});
	WebIM.conn.send(msg.body);
}
var WebIM = {}
// 初始化IM SDK
WebIM = window.WebIM = websdk;
WebIM.config = config;
WebIM.conn = new WebIM.connection({
	appKey: WebIM.config.appkey,
	isHttpDNS: WebIM.config.isHttpDNS,
	isMultiLoginSessions: WebIM.config.isMultiLoginSessions,
	https: WebIM.config.https,
	url: WebIM.config.xmppURL,
	apiUrl: WebIM.config.apiURL,
	isAutoLogin: true,
	heartBeatWait: WebIM.config.heartBeatWait,
	autoReconnectNumMax: WebIM.config.autoReconnectNumMax,
	autoReconnectInterval: WebIM.config.autoReconnectInterval,
	isStropheLog: WebIM.config.isStropheLog,
	delivery: WebIM.config.delivery
});
if (!WebIM.conn.apiUrl) {
	WebIM.conn.apiUrl = WebIM.config.apiURL;
}
if (localStorage.getItem('webIm') != 'err'&&localStorage.getItem('webIm')) {
	onLoginWebIm()
}

function onLoginWebIm () {
	let data = JSON.parse(localStorage.getItem('principal'))
	WebIM.conn.open({
		apiUrl: WebIM.config.apiURL,
		user: data.id,
		pwd: data.id.slice(1,-1), 
		appKey: WebIM.config.appkey,
		success:function (re) {
			localStorage.setItem('webIm',JSON.stringify(re))
			console.log('登陆成功')
		},
		error:function (err) {
			localStorage.setItem('webIm','err')
		}
	})
}

// 注册监听回调
WebIM.conn.listen({
	onOpened: function (message) { // 连接成功回调
		// 登录或注册成功后 跳转到好友页面
		console.log("onOpened", message);
	},
	onError : function (message) {
		console.log("onError", message);
	}, // 连接关闭回调
	onClosed: function (message) {
		console.log("onClosed", message);
	}, // 连接关闭回调
	onOffline: function () {
		console.log("onOffline");
	},//本机网络掉线
	onTextMessage: function (message) {
		store.commit("updateMessageMid", message);
		console.log("onTextMessage", message);
	}, // 收到文本消息
	onEmojiMessage: function (message) {
		store.commit("updateMessageMid", message);
		console.log("onEmojiMessage", message);
	}, // 收到表情消息
	onPictureMessage: function (message) {
		console.log("onPictureMessage", message);
		store.commit("updateMessageMid", message);
	}, // 收到图片消息
	onAudioMessage: function (message) {
		// console.log(message)
		console.log("onAudioMessage", message);
		store.commit("updateMessageMid", message);
	}, // 收到音频消息
	onFileMessage: function (message) {
		console.log("onFileMessage", message);

	}, // 收到文件消息
	onVideoMessage: function (message) {
		console.log("onVideoMessage", message);
	}, // 收到视频消息
	onReceivedMessage: function (message) {
		console.log("onReceivedMessage", message);
		// store.commit("updateMessageMid", message);
		message.status = "sent";
		store.commit("updateMessageStatus", message);
	}, // 收到消息送达服务器回执
	onDeliveredMessage: function (message) {
		console.log("onDeliveredMessage", message);
		store.commit('updateMessageStatus', message)
	}, // 收到消息送达客户端回执
	onReadMessage: function (message) {
		console.log("onReadMessage", message);
		store.commit("updateMessageStatus", message);
	} // 收到消息已读回执
});

WebIM.WebRTC = webrtc;
// WebIM.EMedia = emedia;
WebIM.EMedia = webrtc.emedia;

export default WebIM;



// WEBPACK FOOTER //
// ./src/libs/webIM/WebIM.js